import isLatLong from 'validator/lib/isLatLong';

export const greaterThanZero = {
  validator(value: number) {
    return value > 0;
  },
  message(props: any) {
    return `must be > 0, got ${props.value}`;
  },
};

export const greaterThanEqualToZero = {
  validator(value: number) {
    return value >= 0;
  },
  message(props: any) {
    return `must be >= 0, got ${props.value}`;
  },
};

export const arrayMustNotBeEmpty = {
  validator(array: any[]) {
    const arrayWithValidFields = array.filter(v => v !== undefined);
    return arrayWithValidFields.length > 0;
  },
  message(props: any) {
    return `must have at least 1 element in it, got ${props.value}`;
  },
};

export const arrayObjectsSorted = (key: string) => ({
  validator(array: any[]) {
    if (array.length <= 1) return true;
    for (let i = 1; i < array.length; i++) {
      const current = array[i][key];
      const last = array[i - 1][key];
      if (last > current) {
        throw new Error(`elements should be sorted by '${key}' property`);
      }
    }
    return true;
  },
  message: (props: any) => props.reason.message,
});

export const arrayMaxLengthValidator = (maxLength: number) => ({
  validator(array: any[]) {
    return array.length <= maxLength;
  },
  message(props: any) {
    return `can't have more than ${maxLength} elements`;
  },
});

export const longLat = {
  validator(value: number[]) {
    if (value.length !== 2) {
      throw new Error('it needs to have 2 elements in the array [long,lat]');
    }
    const latLngStr = `${value[1]},${value[0]}`;
    if (!isLatLong(latLngStr)) {
      throw new Error('it is not a valid [long,lat]');
    }
    return true;
  },
  message: (props: any) => props.reason.message,
};
